import { combineReducers } from 'redux'
import authReducers from './authReducers/index.js'

export default combineReducers({
    authReducers
})